import { Resources, ResourcesCellProps } from "."

import type { Resources as TResources } from "./Resources.types"

export const ResourcesCell = (props: ResourcesCellProps) =>
  function ResourcesCellComponent(resources: TResources) {
    return <Resources popover resources={resources} {...props} />
  }
